import React, { useMemo } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import KeyFeatureCard from "../cards/KeyFeatureCard";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: `url('/images/bg/key-feature.png')no-repeat`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      [theme.breakpoints.down("sm")]: {
        backgroundPosition: "inherit",
        backgroundSize: "cover",
      },
    },
  })
);

const KeyFeatures: React.FC<KeyFeaturesProps> = ({ content }) => {
  const classes = useStyles();
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.down("xs"));
  const data = useMemo(() => {
    let features = [];
    if (
      content.contents &&
      isArray(content.contents) &&
      !isEmpty(content.contents)
    ) {
      features = content.contents[0].list;
    } else if (
      content.contents &&
      isArray(content.description) &&
      !isEmpty(content.description)
    ) {
      features = content.description;
    }
    return {
      heading: content.topic_name,
      features: features,
    };
  }, [content]);

  return (
    <Box
      paddingY={[3, 5, 7, 8]}
      className={classes.root}
      color="#ffffff"
      component="section"
    >
      <Container>
        <Box pb={[2, 3, 4, 5]}>
          <Typography align="center" variant="h2" component="h2">
            {data.heading}
          </Typography>
        </Box>

        <Grid container spacing={xs ? 2 : 6}>
          {data.features?.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={4}
              key={`keyfeature-of-course-` + index}
            >
              <KeyFeatureCard count={index + 1} point={item} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default KeyFeatures;
